import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeReader } from '../features/Reader';

const Reader = ({headerHeight}) => {
  const readerSource = useSelector((state) => state.reader.value.readerSource);
  const dispatch = useDispatch();

  useEffect(() => {
    if (readerSource) {
      // Prevent scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Allow scrolling
      document.body.style.overflow = 'auto';
    }

    // Cleanup function to reset the overflow style when the component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [readerSource]);

  return (
    <div className="relative">
      {readerSource ? (
        <div
          className={`fixed inset-0 bg-white z-10`}
          style={{ marginTop: `${headerHeight}px` }}
        >
          <div className="flex justify-center bg-[#2196F3]">
            <button
              onClick={() => {
                dispatch(closeReader());
              }}
              className="w-[100%] font-bold text-white p-3"
            >
              CERRAR
            </button>
          </div>
          <iframe src={readerSource} className="bg-white w-[100%] h-[100%]" />
        </div>
      ) : null}
    </div>
  );
};

export default Reader;
